import createReactClass from 'create-react-class';
import React from 'react';
import ReactDOM from 'react-dom';
import { pollStore } from '../stores/poll';
import { ServerActions } from '../actions/serverActions';
import { PollActions } from '../actions/pollActions';
import { createRoot } from 'react-dom/client';

var interval;

function getStateFromStores() {
    return {
        id: pollStore.idToPoll(),
        isPolling: pollStore.isPolling(),
        pollingInterval: pollStore.getInterval(),
        isBlocking: pollStore.isBlocking()
    }
}


function poll() {
    var id = pollStore.idToPoll();
    if (id) {
        if (pollStore.stopPolling()) {
            PollActions.stopPollingDueToMaxAttemptsReached(id);
        }
        else {
            ServerActions.pollServer(id);
        }
    }
}

var Poller = createReactClass({
    componentDidMount: function () {
        pollStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        pollStore.unsubscribe(this._onChange);
        if (interval) {
            clearTimeout(interval);
        }
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    render: function () {

        if (this.state.id && !this.state.isPolling) {
            //always set the next interval, this changes with the number of failures
            interval = setTimeout(poll, this.state.pollingInterval);
            // console.log('Setting next poll to occur [', this.state.pollingInterval, ']ms from now');
        }

        var blockingClass = "", loader = "";
        if (this.state.isBlocking) {
            blockingClass = "blockingInput";
            loader = (<div id='loader' className="loader-inner line-spin-fade-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>);
        }

        var content = (
            <div className={blockingClass}>
                {loader}
            </div>
        );

        return content;
    }
});


function initialize() {
    const root = createRoot(document.getElementById('pollDiv'));
    root.render(<Poller />);
    PollActions.initializePoll();
}

export {
    Poller as poller,
    initialize
};

